module.exports = __webpack_public_path__ + "assets/img/stewed.2d607f18.png";